import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { noop } from 'lodash';
import { Menu, Tooltip } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import useAcceptDelegationAction from 'components/tables/data/revision/actions/hooks/use-accept-delegation-action';
import { useConfirm } from 'components/modals/message/MessageProvider';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by a delegated user to accept the delegation.
 */
export default function AcceptDelegationAction({ revision, onStatusChange = noop, kind }: RevisionSingleActionProps) {
  const { acceptDelegation } = useAcceptDelegationAction();
  const { confirm } = useConfirm();

  /**
   * Confirms the acceptance of the delegation
   */
  const confirmAcceptDelegation = () =>
    confirm({
      title: 'Prijať delegovanie',
      content:
        revision.kind === 'revision'
          ? 'Naozaj si prajete prijať delegovanie tejto revíznej správy?'
          : 'Naozaj si prajete prijať delegovanie tohto formulára?',
      onConfirm: () => acceptDelegation({ revision, onStatusChange }),
    });

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Prijať delegovanie" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="primary" size="md" onClick={confirmAcceptDelegation}>
          <IconCheck />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button variant="primary" size="md" onClick={confirmAcceptDelegation} leftIcon={<IconCheck />} w={188}>
        Prijať delegovanie
      </Button>
    );
  }

  return (
    <Menu.Item color="gray.8" onClick={confirmAcceptDelegation} icon={<IconCheck stroke={1.5} size={20} />}>
      Prijať delegovanie
    </Menu.Item>
  );
}
